function moveToTrashDialog () {
  return {
    restrict: 'E',
    templateUrl: '/repository/dialogs/move-to-trash/move-to-trash-dialog.html?$$REVISION$$'
  }
}

export { moveToTrashDialog }
